import React from 'react';

import Drawer from "../common/Drawer";
import Seo from '../common/Seo';

import Banner from "./include/Banner";
import Details from "./include/Details";
import Features from "./include/Features";
import Gallery from "./include/Gallery";
import HeroHeader from "./include/HeroHeader";
import Stores from "./include/Stores";
import CallToAction from '../common/CallToAction';
import { routeIds } from '../i18n/routes';
import { useI18n } from '../i18n/I18nContext';

function Project({route, project}) {
  const { pathFor, projectPathFor, t } = useI18n();
  var extraComponents = project.screenshots || project.features || project.stores;
  const title = `${project.title} | CDO Apps`;

  const components = [
    <Seo title={title} description={project.description} path={projectPathFor(project.slug)} />,
    <Banner title={project.title} image={project.banner} />,
    <HeroHeader title={project.title} description={project.description} image={project.image} techs={project.techs} website={project.website} />,
    <Details info={project.info} focus={project.focus} lastSection={!extraComponents} />
  ];

  if (project.screenshots) {
    extraComponents = project.features || project.stores;
    components.push(<Gallery title={project.title} screenshots={project.screenshots} preserveAspectRatio={project.preserveScreenshotAspectRatio} lastSection={!extraComponents} />);
  }

  if (project.features) {
    extraComponents = project.stores;
    components.push(<Features title={project.title} features={project.features} lastSection={!extraComponents} />);
  }

  if (project.stores) {
    components.push(<Stores appStore={project.stores.appStore} googlePlay={project.stores.googlePlay} steam={project.stores.steam} />);
  }

  return [
    ...components,
    <CallToAction id="contact" title={t("pages.projects.ctaTitle")} text={t("pages.projects.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <Drawer route={route} />
  ];
}

export default Project;
